export default {
  getUsersData (state) {
    return state.usersData;
  },
};